<!-- Forgot password email request view -->
<section class="form-group" [ngClass]="{ 'd-none': loading }">
  <article
    [ngClass]="theme.getThemeClass()"
    class="wrapper fadeInDown wrapperAdds"
  >
    <img class="logo" src="../assets/muirwood-studio.png" />
    <h2 class="text-center">
      {{ "loginForgotPassword" | translate }}
    </h2>
    <p>{{ "loginForgotPasswordMessage" | translate }}</p>
    <form
      (ngSubmit)="ctx.sendForgotPasswordEmail()"
      id="register-form"
      role="form"
      autocomplete="off"
      class="form"
      method="post"
    >
      <div [ngClass]="theme.getThemeClass()" class="form-group">
        <div class="input-group">
          <!-- Input for user email -->
          <input
            type="email"
            id="email"
            [(ngModel)]="ctx.email"
            class="form-control"
            name="email"
            placeholder="{{
              'loginForgotPasswordPlaceHolderEmailAddress' | translate
            }}"
            required
            minlength="1"
            #resetPassword="ngModel"
            email="true"
            (input)="ctx.checkEmail()"
          />
        </div>
        <!-- Button to send email of reset password to the user -->
        <nav [ngClass]="theme.getThemeClass()" class="divBtn">
          <a class="btnA">
            <div class="btn">
              <input
                class="inputBtn"
                name="recover-submit"
                value="{{
                  'loginForgotPasswordBtnResetPassword' | translate
                }}"
                type="submit"
              />
            </div>
          </a>
        </nav>
      </div>
    </form>
  </article>
</section>
